import { createSlice } from '@reduxjs/toolkit'
import type { PayloadAction } from '@reduxjs/toolkit'

import { PhoneState } from './types'
import { fetchDirectory, postCall } from './phoneThunk'

const initialState: PhoneState = {
  directory: {
    data: [],
    loading: false,
    error: null,
  },
  call: {
    data: null,
    loading: false,
    error: null,
  },
}

const phoneSlice = createSlice({
  name: 'phone',
  initialState,
  reducers: {
    clearCall: (state) => {
      state.call.data = null
      state.call.error = null
      state.call.loading = false
    },
    clearDirectory: (state) => {
      state.directory.data = []
      state.directory.error = null
      state.directory.loading = false
    },
  },

  extraReducers: (builder) => {
    builder

      .addCase(fetchDirectory.pending, (state) => {
        state.directory.loading = true
        state.directory.error = null
      })
      .addCase(fetchDirectory.fulfilled, (state, action) => {
        state.directory.loading = false
        state.directory.data = action.payload
      })
      .addCase(fetchDirectory.rejected, (state, action) => {
        state.directory.loading = false
        state.directory.error = action.payload as string
      })

      .addCase(postCall.pending, (state) => {
        state.call.loading = true
        state.call.error = null
      })
      .addCase(postCall.fulfilled, (state, action) => {
        state.call.loading = false
        state.call.data = action.payload
      })
      .addCase(postCall.rejected, (state, action) => {
        state.call.loading = false
        state.call.error = action.payload as string
        state.call.data = null
      })
  },
})

export const { clearCall, clearDirectory } = phoneSlice.actions

export default phoneSlice.reducer
